var n = /* @__PURE__ */ ((e) => (e.Empty = "Empty", e.Listing = "Listing", e.Renting = "Renting", e.OwnerRenting = "OwnerRenting", e))(n || {}), s = /* @__PURE__ */ ((e) => (e[e.Open = 0] = "Open", e[e.Invite = 1] = "Invite", e[e.Owner = 2] = "Owner", e))(s || {}), g = /* @__PURE__ */ ((e) => (e[e.Star_Owner = 0] = "Star_Owner", e[e.Planet_Owner = 1] = "Planet_Owner", e[e.Renew = 2] = "Renew", e))(g || {}), A = /* @__PURE__ */ ((e) => (e[e.Loading = 0] = "Loading", e[e.NoAttach = 1] = "NoAttach", e[e.RentAttach = 2] = "RentAttach", e[e.TransferredAttach = 3] = "TransferredAttach", e[e.SelfAttach = 4] = "SelfAttach", e))(A || {}), i = /* @__PURE__ */ ((e) => (e.AgingBuffAsc = "AgingBuffAsc", e.AgingBuffDesc = "AgingBuffDesc", e.AttachPlanetIDAsc = "AttachPlanetIDAsc", e.AttachPlanetIDDesc = "AttachPlanetIDDesc", e.PriceAsc = "PriceAsc", e.PriceDesc = "PriceDesc", e.ListingTimeDesc = "ListingTimeDesc", e.RentalEndTimeDesc = "RentalEndTimeDesc", e.StarOrbitalTrackSlotAsc = "StarOrbitalTrackSlotAsc", e))(i || {});
const D = [
  {
    id: 0,
    nameId: "orbit.list.sort.cheap",
    value: "PriceAsc"
    /* PriceAsc */
  },
  {
    id: 1,
    nameId: "orbit.list.sort.expensive",
    value: "PriceDesc"
    /* PriceDesc */
  },
  {
    id: 2,
    nameId: "orbit.list.sort.young",
    value: "AgingBuffAsc"
    /* AgingBuffAsc */
  },
  {
    id: 3,
    nameId: "orbit.list.sort.old",
    value: "AgingBuffDesc"
    /* AgingBuffDesc */
  },
  {
    id: 4,
    nameId: "orbit.list.sort.recent",
    value: "ListingTimeDesc"
    /* ListingTimeDesc */
  }
], f = "0";
export {
  A as OrbitalTrackAttachStatus,
  g as OrbitalTrackRentalPopupType,
  s as OrbitalTrackSectionMode,
  i as OrbitalTrackSortBy,
  D as OrbitalTrackSortItems,
  n as OrbitalTrackState,
  f as PUBLIC_RENTAL_GROUP_ID
};
//# sourceMappingURL=orbitalTrack.js.map
